export default {
      id: "btn-shape-v-flip-usage",
      viewBox: "0 0 55 54",
      url: "../../assets/" + "sprite.svg#btn-shape-v-flip-usage",
      toString: function () {
        return this.url;
      }
    }